export enum EAgentType {
  CA = 'CA',
  ICB = 'ICB',
  ECB = 'ECB'
}
